module.exports = __webpack_public_path__ + "img/montserrat.bab8a79.webp";